import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useStyles from "../hooks/useStyles";
import Help from "./Help";
import { OutputBody, OutputBox, OutputButton, OutputColor, OutputFooterWithPercentage, OutputHeader } from "./OutputBox";
import Points from "./Points";
import ScrollBox from "./ScrollBox";
import TestResults from "./TestResults";
var SubmissionOutput = function (props) {
  var _a;
  var getPasteLink = props.getPasteLink,
    onClose = props.onClose,
    onSubmit = props.onSubmit,
    testResults = props.testResults,
    pasteDisabled = props.pasteDisabled,
    outputHeight = props.outputHeight;
  var t = useTranslation()[0];
  var _b = useState(false),
    showAllTests = _b[0],
    setShowAllTests = _b[1];
  var classes = useStyles();
  var percentage = Math.round(100 * testResults.testCases.filter(function (x) {
    return x.passed;
  }).length / testResults.testCases.length);
  var scrollBoxRef = React.createRef();
  return React.createElement(OutputBox, null, React.createElement(OutputHeader, {
    title: t("submissionResult"),
    color: OutputColor.Gray
  }, React.createElement(Help, {
    getPasteUrl: getPasteLink,
    pasteDisabled: pasteDisabled
  }), React.createElement(OutputButton, {
    label: t("button.close"),
    onClick: onClose,
    dataCy: "close-btn"
  })), React.createElement(OutputBody, null, React.createElement(ScrollBox, {
    maxHeight: outputHeight,
    ref: scrollBoxRef
  }, React.createElement(TestResults, {
    results: testResults,
    showAllTests: showAllTests
  }, testResults.points.length > 0 && React.createElement(Points, {
    points: testResults.points
  })))), React.createElement(OutputFooterWithPercentage, {
    color: OutputColor.Gray,
    percentage: percentage,
    showAll: showAllTests,
    setShowAll: setShowAllTests,
    showAllDisabled: testResults.testCases.length === 1 && ((_a = !testResults.allTestsPassed) !== null && _a !== void 0 ? _a : false)
  }, !testResults.allTestsPassed && React.createElement(OutputButton, {
    disabled: false,
    label: t("button.submit"),
    onClick: onSubmit,
    dataCy: "submit-btn",
    className: classes.blueButton
  })));
};
export default SubmissionOutput;